export default {
  meta: {
    title: '销售单管理'
  }
};
